import { useClient } from "#/hook/useClient";

/** Route the TMA admin switches on per client; must match tma-be `WebRoute.SHIPMENT_MANIFESTS`. */
export const SHIPMENT_MANIFESTS_ROUTE = "/fleet/shipment-manifests";

/**
 * Whether Shipment Manifests is on for the current client, using the same
 * rule as the sidebar and the backend: an empty or missing `allowedRoutes`
 * list means every route is on. No client (e.g. admin) means off, because
 * every manifest endpoint is client-scoped.
 */
export function useShipmentManifestsEnabled(): boolean {
  const { client } = useClient();
  if (!client) return false;
  const routes = client.allowedRoutes;
  if (!Array.isArray(routes) || routes.length === 0) return true;
  return routes.includes(SHIPMENT_MANIFESTS_ROUTE);
}
